import React, { useState, createContext, useContext } from 'react';

export interface INavbarContext {
  opened: boolean;
  toggleNavbar: () => void;
  open: () => void;
  close: () => void;
}

export const NavbarContext = createContext<INavbarContext | null>(null);

interface IPlayerProvider {
  children?: React.ReactNode;
}

const NavbarProvider: React.FC<IPlayerProvider> = ({ children }) => {
  const [opened, setOpened] = useState(false);

  const toggleNavbar = () => {
    setOpened((prev) => !prev);
  };

  const open = () => {
    setOpened(true);
  };

  const close = () => {
    setOpened(false);
  };

  const value = {
    opened,
    toggleNavbar,
    open,
    close,
  };

  return (
    <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
  );
};

export const useNavbar = () => useContext(NavbarContext) as INavbarContext;

export default NavbarProvider;
